<template>
  <div
    class="relative w-full flex-col items-center text-white bg-[#030C19] bg-news-bg bg-no-repeat bg-cover bg-top mt-[20px] pt-[100px] lg:pt-[100px] pb-[100px] px-6"
  >
    <div class="w-full h-full flex flex-col items-center justify-start">

      <!-- Header -->
      <div class="w-full flex flex-col items-center justify-center gap-2 relative mb-6">
        <div
          class="w-full max-w-[1000px] font-black text-center py-3 sm:px-6 rounded-[10px] border border-[#4fc3f7] text-[#4fc3f7] font-orbitron text-[18px] sm:text-[24px] shadow-[0_0_15px_#4fc3f7aa] bg-gradient-to-r from-[#030C19]/10 to-[#2EBBF0]/10 backdrop-blur-md"
        >
          {{ $t('News.Header') }}
        </div>
      </div>

      <!-- Clipped News Container -->
      <div class="relative w-full max-w-[1000px] mx-auto mt-[40px]">
        <!-- Border Layer -->
        <div
          class="absolute inset-0 z-0 pointer-events-none"
          style="clip-path: polygon(0% 60px, 60px 0%, 100% 0%, 100% calc(100% - 60px), calc(100% - 60px) 100%, 0% 100%); box-shadow: 0 0 25px #4fc3f7aa;"
        ></div>

        <!-- Inner Clipped Content -->
        <div
          class="relative z-10 bg-white/10 backdrop-blur-md px-6 sm:px-10 py-12"
          style="clip-path: polygon(0% 60px, 60px 0%, 100% 0%, 100% calc(100% - 60px), calc(100% - 60px) 100%, 0% 100%)"
        >
          <!-- Banner Image -->
          <img :src="news.image" alt="News Banner" class="w-full rounded-xl mb-8" />

          <!-- News Title -->
          <h2 class="text-xl sm:text-2xl font-black text-[#2EBBF0] mb-4 font-orbitron">
            {{ news.title }}
          </h2>

          <!-- Meta Info -->
          <div class="flex flex-wrap items-center gap-4 text-sm text-white/70 mb-6">
            <div class="flex items-center gap-2">
              <img src="@/assets/calendar.png" alt="Calendar" class="w-4 h-4" />
              <span>{{ news.date }}</span>
            </div>

            <!-- Tags -->
            <div class="flex flex-wrap gap-2">
              <span v-for="(tag, idx) in news.tags" :key="idx" class="px-3 py-1 border border-[#2EBBF0] text-xs rounded-full font-semibold text-white">
                {{ tag }}
              </span>
            </div>
          </div>

          <!-- Headline Blocks -->
          <div class="mb-6">
            <h3 class="font-bold text-white text-lg sm:text-xl uppercase leading-snug mb-3">
              {{ news.headline }}
            </h3>
            <p class="text-white/80 text-sm sm:text-base leading-relaxed">
              {{ news.subheadline }}
            </p>
          </div>

          <!-- Full Content Blocks -->
          <div class="space-y-6">
            <p v-for="(para, idx) in news.content" :key="idx" class="text-white/90 text-sm sm:text-base leading-loose">
              {{ para }}
            </p>

            <img :src="news.image" alt="News Inline" class="w-full rounded-md border border-white/20" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetailsPage",
  data() {
    return {
      news: {
        title: "LOREM IPSUM EU MAGNIS SED URNA NEQUE ADIPISCING NEC LUCTUS.",
        date: "May 02, 2025",
        image: require("@/assets/about-card.avif"),
        tags: ["NEW SLOT", "PRAGMATIC PLAY", "HIGH VOLATILITY"],
        headline: "729 WAYS TO WIN ON A 6X3 GRID WITH HIGH VOLATILITY ACTION",
        subheadline: "MAXIMUM WIN OF 4,000X YOUR STAKE • MYSTERY, MONEY & COLLECT SYMBOLS SPICE UP EVERY SPIN",
        content: [
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod semper tincidunt ut. Lorem et dictum magna aliquam. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit.",
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod semper tincidunt ut. Lorem et dictum magna aliquam. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit.",
        ]
      }
    };
  }
};
</script>
